import styled from 'styled-components';

import { TABLET_WIDTH } from 'commons/constants/size';

export const InvoiceContainer = styled.div`
  display: flex;
  flex-direction: column;

  @media only screen and (max-width: ${TABLET_WIDTH}px) {
    padding: ${({ theme }) => theme.noodera.spacing.x6};
    margin-bottom: ${({ theme }) => theme.noodera.spacing.x1};
  }
`;

export const HeaderTitle = styled.h1`
  ${({ theme }) => theme.noodera.fontTypes.font3Medium};
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${({ theme }) => theme.noodera.spacing.x8};
  align-self: stretch;
`;

export const StyledContainer = styled.div`
  display: flex;
  width: 720px;
  flex-direction: column;
  align-items: center;
`;

export const InvoiceHeaderContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.noodera.spacing.x9};
  flex: 1 0 0 0;
`;

export const MainContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
`;

export const FormContainer = styled.form`
  display: contents;
  gap: ${({ theme }) => theme.noodera.spacing.x3};
`;

export const FormWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;
